module.exports = __webpack_public_path__ + "static/img/img_zhanlue.5bb56809.png";